

export const toNative = (userAgent) => {

  let isWX = userAgent.match(/MicroMessenger/i) != null;
  let isIOS = userAgent.match(/iPhone/i)||userAgent.match(/iPad/i) != null;

  if (isWX) {
    location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.weimi.mzg.ws'
  }else if (isIOS) {
    location.href = 'https://itunes.apple.com/cn/app/wen-shen-da-ka-zui-hao-wen/id1022212399?mt=8'
  }else {
    location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.weimi.mzg.ws'
  }
};



// WEBPACK FOOTER //
// ./src/libs/other.js